module.exports = __webpack_public_path__ + "static/ncl-qikober-regular-2cab8b0edf9cbf3681d108227ea9c8cc.woff2";